import React from 'react';
import {
    ButtonGroup,
    Button,
    Select,
    Option,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from '@ecster/components';

import { setBaseUrl } from '@ecster/net';

const { EcsterConfig: conf } = window;

const urls = [
    ['<relative>', 'relative'],
    ['PR', 'https://secure.ecster.se'],
    ['PR LABS', 'https://labs.ecster.se'],
    ['FT', 'https://secure.ft.ecster.se'],
    ['FT1', 'https://secure1.ft.ecster.se'],
    ['LABS', 'https://labs.ft.ecster.se'],
    ['LABS 1', 'https://labs1.ft.ecster.se'],
    ['ST', 'https://secure.st.ecster.se'],
    ['PT', 'https://secure.pt.ecster.se'],
];

export default class SelectBackend extends React.Component {
    static propTypes = {};

    static defaultProps = {};

    state = {
        isOpen: false,
        baseURL: conf.baseURL || 'relative',
    };

    openDialog = () => {
        this.setState({ isOpen: true });
    };

    closeDialog = () => {
        this.setState({ isOpen: false });
    };

    onSelect = e => {
        const {
            target: { value },
        } = e;
        this.setState({ baseURL: value });
        window.scrollBy(0, 0);
    };

    saveAndCloseDialog = () => {
        const { baseURL } = this.state;
        conf.baseURL = baseURL === 'relative' ? '' : baseURL;
        setBaseUrl(conf.baseURL);
        this.closeDialog();
    };

    render() {
        const { isOpen, baseURL } = this.state;

        return (
            <div className="authentication-select-backend">
                <ButtonGroup>
                    <Button outline small blue round onClick={this.openDialog}>
                        Select backend
                    </Button>
                </ButtonGroup>
                <Dialog open={isOpen} onRequestClose={this.closeDialog}>
                    <DialogHeader>Select backend</DialogHeader>
                    <DialogBody>
                        <div className="plr-10x ptb-6x">
                            <Select onChange={this.onSelect} value={baseURL}>
                                {urls.map(url => (
                                    <Option key={url[0]} label={url[0]} value={url[1]} />
                                ))}
                            </Select>
                        </div>
                    </DialogBody>
                    <DialogFooter>
                        <ButtonGroup alignCenter>
                            <Button round transparent blue onClick={this.closeDialog}>
                                Cancel
                            </Button>
                            <Button outline blue onClick={this.saveAndCloseDialog}>
                                Go
                            </Button>
                        </ButtonGroup>
                    </DialogFooter>
                </Dialog>
            </div>
        );
    }
}
